
// import config from '../config';
import config from '../assets/config'
import { ax } from './base';
import GV from './globalVar';

export default class LoginService {


    UserLogin(payload){
        return ax.post(`${config.apiUrl}Auth/UserLogin`,payload)
    }

    UserProfile(appUserId){
        return ax.get(`${config.apiUrl}Auth/UserProfile/${appUserId} `);
    }
    TenantSwitch(appUserId){
        return ax.get(`${config.apiUrl}Tenant/GetUserTenantAssociate/${appUserId} `);
    }
    RefreshToken(payload){
        const data = {
            "RefreshToken":localStorage.getItem('lv'),
            "AppUserID":GV.userDet.appUser.appuserID
          } 
        return ax.post(`${config.apiUrl}Auth/RefreshToken`,data)
    }

    ForgetPassword(payload){
        return ax.post(`${config.apiUrl}Auth/ForgetPassword`,payload)
    }
    
    ResetPassword(payload){
        return ax.post(`${config.apiUrl}Auth/ResetPassword`,payload)
    }


  
   
}